import { render } from "./LimitedText.vue?vue&type=template&id=fdab59ae"
import script from "./LimitedText.vue?vue&type=script&lang=js"
export * from "./LimitedText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__